export default __webpack_public_path__ + "static/electrical_panel_b.2e207d1dba7a37fbd5041e3d3b28080c.svg";